<template lang="pug">
  #app
    .contenedor
      transition(name="fade")
        router-view
    bottom-component
    notifications(
      position="top right"
      width="100%"
    )
</template>

<script>
  import Router from './router/admin'
  import BottomComponent from './components/c_menu_bottom'
  export default {
    name: 'adminMovilApp',
    components: {
      BottomComponent
    },
    computed: {
      showProcesos () {
        return this.$store.state.showProcesos
      }
    },
    data () {
      return {
        tabs : [
          {path : '/', nombre : 'Dashboard', id : 0},
          {path : '/planes', nombre : 'Planes', id : 1},
          {path : '/oportunidades', nombre : 'Oportunidades', id : 2},
          {path : '/consultas', nombre : 'Consultas', id : 3}
        ]
      }
    },
    methods : {
      goPreviousTab () {
        var vm = this
        var rutaActual = vm.tabs.find((i) => i.path === vm.$route.path)
        if (rutaActual && rutaActual.id > 0) Router.push(vm.tabs[rutaActual.id - 1].path)
      },
      goNextTab () {
        var vm = this
        var rutaActual = vm.tabs.find((i) => i.path === vm.$route.path)
        if (rutaActual && rutaActual.id < 3) Router.push(vm.tabs[rutaActual.id + 1].path)
      }
    }
  }
</script>
<style lang="stylus">
.text-primary
  color #2e7bda
.bg-primary
  background-color #2e7bda
.border-primary
  border-color #2e7bda
.router-link-exact-active
  color #2e7bda

.contenedor
  height: calc(100vh - 54px);
  overflow-x: auto;

  //Transitions
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(10px);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.2s ease;
}

.slide-up-leave-to {
  transform: translateY(-10px);
}

.slide-up-move {
  transition: all 0.2s ease;
}

.fade-quick-enter {
  opacity: 0;
}

.fade-quick-enter-active,
.fade-quick-leave-active {
  transition: opacity 0.15s ease-in-out;
}

.fade-quick-leave-to {
  opacity: 0;
}

.fade-smooth-two-enter, .fade-smooth-two-leave-active {
  opacity: 0;
}

.fade-smooth-two-leave-active {
  position: absolute;
}

.fade-smooth-enter, .fade-smooth-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-smooth-leave-active {
  position: absolute;
}

.contenedor-transition-box
  display flex
  justify-content center
  flex-direction column
  position relative
  >*
    transition all .5s
    width 100%  

.text-xxs  
  font-size: 0.6rem;

.text-xxxs  
  font-size: 0.5rem;
  
.padding-floating-button
  padding-bottom: 60px
  padding-right: 8px;
</style>



// WEBPACK FOOTER //
// App.vue?2b727cf3